module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/th_kyushu-ef376a6ad10113b2aa0842e678123ab7.jpg";